/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { StandardFilterComponent } from '../standard-filter/standard-filter.component';
import { USWholeNumberPipe } from '@shared/utils/pipes';

@Component({
  selector: 'plp-components-size-filter',
  templateUrl: './size-filter.component.html',
  styleUrl: './size-filter.component.scss',
  imports: [HmfActionTextComponent, USWholeNumberPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SizeFilterComponent extends StandardFilterComponent {
  defaultOpen = input<boolean>(false);

  // Computed for overflow
  hasOverflow = computed(() => this.filterOptions()?.length > 10);

  toggleShowMore() {
    this.showMore.update((v) => !v);
    this.showMoreChange.emit(this.showMore());
  }

  setSelectedFilter(value: string) {
    this.selectedFilter.emit(value);
  }
}
